module.exports = {
  CARD_SETTLEMENT_STATUS: {
    READY: 'READY',
    PENDING: 'PENDING',
    IN_PROGRESS: 'IN_PROGRESS',
    AWAITING_AT_SP: 'AWAITING_AT_SP',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED'
  },
  CARD_SETTLEMENT_PROCESS: {
    STP: 'STP',
    MANUAL: 'MANUAL',
    BATCH: 'BATCH'
  },
  UPDATE_SETTLEMENT_METHOD: {
    CRON: 'CRON',
    WEBHOOK: 'WEBHOOK'
  }
};
